/**
 * Dedupes session-expiry toasts when many API calls fail with 401/403 at once.
 */
let handling = false

export function beginSessionExpiryHandling () {
  if (handling) return false
  handling = true
  return true
}

export function resetSessionExpiryHandling () {
  handling = false
}
